"use client";

import { Award, Clock, Shield, Users } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function WhyChooseUs() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const reasons = [{
    id: 1,
    icon: Shield,
    title: "Professional & Reliable",
    description: "Licensed, insured drivers with years of experience providing safe and punctual transportation services."
  }, {
    id: 2,
    icon: Award,
    title: "Premium Fleet",
    description: "Luxury sedans, SUVs, and high-end luxury vehicles maintained to the highest standards for your comfort."
  }, {
    id: 3,
    icon: Clock,
    title: "24/7 Availability",
    description: "Round-the-clock service to meet your schedule, whether early morning flights or late-night events."
  }, {
    id: 4,
    icon: Users,
    title: "Personalized Service",
    description: "Tailored transportation solutions for airport transfers, corporate travel, and special occasions."
  }];
  return <section className="bg-background py-16 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <div ref={headerRef} className={`mb-12 text-center transition-all duration-700 ${headerVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          <h2 className="font-display text-4xl font-bold text-foreground sm:text-5xl">
            Why Choose Us
          </h2>
          <p className="mt-4 text-lg text-muted">
            Experience the difference with Car Service Connecticut
          </p>
        </div>

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {reasons.map((reason, i) => {
          const {
            ref,
            isVisible
          } = useRevealOnScroll({
            once: true,
            threshold: 0.1
          });
          const Icon = reason.icon;
          return <div key={reason.id} data-index={i} ref={ref} className={`transition-all duration-700 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`} style={{
            transitionDelay: `${i * 100}ms`
          }}>
                <Card className="card h-full border border-border/30 hover:border-accent/40">
                  <CardHeader>
                    <div className="mb-4 inline-flex items-center justify-center rounded-lg bg-accent/10 p-3">
                      <Icon className="size-6 text-accent" />
                    </div>
                    <CardTitle className="text-xl text-foreground-secondary">
                      {reason.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="text-sm text-muted-dark leading-relaxed">
                      {reason.description}
                    </p>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}